import * as angular from 'angular';
import {IController} from "angular";

export class RelationsIndicatorCtrl implements IController {
  count: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('relationsIndicator', {
    bindings: {
      count: '<'
    },
    template: require('./relations-indicator.html').default,
    controller: RelationsIndicatorCtrl
  });
